import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import EmailForm from '../containers/EmailFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class EmailEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `EmailEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('email_route_edit')} />
          <EmailForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default EmailEditScreen;

Logger.log('silly', `EmailEditScreen loaded.`);
